import { render } from "./SVGList.vue?vue&type=template&id=ce2830f8"
import script from "./SVGList.vue?vue&type=script&lang=js"
export * from "./SVGList.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__